<template>
  <li class="results-meta__breadbox">
    <button class="results-meta__breadbox-btn u-bg-primary-medium-dark u-hover-bg-primary-medium-dark-2 u-sans-serif u-type-11" @click="removeFilter()">
      {{ filter.name }}
      <span class="visuallyhidden">Remove filter</span>
    </button>
  </li>
</template>

<script>

  import { mapGetters } from 'vuex'

  export default {
    name: 'Breadbox',
    props: ['filter'],
    methods: {
      removeFilter: function () {
        var filters = this.activeFilters

        // if has children unselect all children
        if(this.filter.children) {
          for (const [i, child] of Object.entries(this.filter.children)) {
            let index = filters.indexOf(child)
            // if child is selected unselect
            if(index > -1) {
              filters.splice(index, 1) // remove elements starting at given index limit 1
            }
          }
        }

        var index = filters.indexOf(this.filter)
        filters.splice(index, 1)
        this.$store.commit('updateActiveFilters', filters)
      }
    },
    computed: {
      ...mapGetters({
        activeFilters: 'getActiveFilters',
      })
    }
  }

</script>
